import { defineComponent } from 'vue'
import { WdsIcon, WdsStack } from '@worksome/wds-components'
import Notification from '@/utils/notification/Notification'
import enums from '@/utils/enum'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

// Push notifications to this little bus for small toasts on page load
const NotificationBus: Notification[] = []

const fireAccountSwitchedNotification = () => {
  const accountSwitchedParamName = '_acc_switched'
  const url = new URL(window.location.href)

  if (url.searchParams.get(accountSwitchedParamName) === '1') {
    url.searchParams.delete(accountSwitchedParamName)

    // Update URL to remove the account switch param:
    window.history.replaceState(null, '', url.toString())

    NotificationBus.push(
      new Notification({
        content: defineComponent({
          components: {
            WdsIcon,
            WdsStack,
          },
          setup() {
            return {
              teamName: currentAccount.name,
            }
          },
          methods: {
            $t,
          },
          template: `<WdsStack gap-sm justify-center align-center>
          <WdsIcon name="compare"/>
          <WdsStack gap-none vertical>
            <span>{{ $t('Switched team to: :team', { team: teamName }) }}</span>
          </WdsStack>
        </WdsStack>`,
        }),
        type: enums.notification.types.NETWORK,
        config: {
          timeout: 8000,
          icon: false,
        },
      }),
    )
  }
}

const emptyNotificationBus = () => {
  while (NotificationBus.length > 0) {
    const notification = NotificationBus.pop()
    if (notification) {
      notification.dispatch()
    }
  }
}

// Function to add logic to for functions that run once on a full page load.
export function runPageLoadFunctions() {
  fireAccountSwitchedNotification()
}

export function postPageLoadFunctions() {
  emptyNotificationBus()
}
